
import React from 'react';

const LoadControlHeader: React.FC = () => {
  return (
    <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-white">Load Control</h2>
  );
};

export default LoadControlHeader;
